import { flow, makeObservable, observable } from 'mobx';
import { GeneralApi } from '../apis';
import BaseStore from './BaseStore';

class GeneralStore extends BaseStore {

    exchanges = [];
    blockchainNetworks = [];
    tokens = [];

    pagingNetwork = {
        ...this.defaultPaging
    }

    pagingToken = {
        ...this.defaultPaging
    }

    constructor(rootStore) {
        super();
        makeObservable(this, {
            exchanges: observable,
            blockchainNetworks: observable,
            tokens: observable,
            getAllExchanges: flow.bound,
            getAllNetworks: flow.bound,
            getAllTokens: flow.bound
        })
        this.rootStore = rootStore;
        this.api = new GeneralApi();
    }

    *getAllExchanges(searchParams) {
        try {
            const { size, page, sortDir, sortKey } = this.paging;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getAllExchanges, payload);
            if (res?.ok) {
                this.exchanges = res?.data?.elements || [];
                this.setAttrObservable('paging', res?.data?.paginate, true, false);

                return res?.data?.elements || [];
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getAllNetworks(searchParams) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingNetwork;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getAllBlockchainNetwork, payload);
            if (res?.ok) {
                this.blockchainNetworks = res?.data?.elements || [];
                this.setAttrObservable('pagingNetwork', res?.data?.paginate, true, false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    *getAllTokens(searchParams) {
        try {
            const { size, page, sortDir, sortKey } = this.pagingToken;
            const payload = { size, page, sortDir, sortKey, ...searchParams };
            const res = yield this.rootStore.apiStore.call(this.api, this.api.getAllTokens, payload);
            if (res?.ok) {
                this.tokens = res?.data?.elements || [];
                this.setAttrObservable('pagingToken', res?.data?.paginate, true, false);

                return res?.data?.elements || [];
            }
        } catch (error) {
            console.log(error);
        }
    }

    clean() {
        super.clean();
        this.exchanges = [];
        this.blockchainNetworks = [];
    }
}

export default GeneralStore;